export default __webpack_public_path__ + "static/media/custom-splatter-06.3e8b92ef.jpg";